import { render, staticRenderFns } from "./HintLabel.vue?vue&type=template&id=3098267b&scoped=true"
import script from "./HintLabel.vue?vue&type=script&lang=js"
export * from "./HintLabel.vue?vue&type=script&lang=js"
import style0 from "./HintLabel.vue?vue&type=style&index=0&id=3098267b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098267b",
  null
  
)

export default component.exports